// SPDX-FileCopyrightText: Copyright 2025 OP Financial Group (https://op.fi). All Rights Reserved.
//
// SPDX-License-Identifier: LicenseRef-OpAllRightsReserved

import React from 'react';
import message from '../../../messages';
import { Button, Col, Row } from '@op/opds.opux';
import { IconDelete } from '@op/opds.opux-icons/action';

interface AdminInformationFormHeaderProps {
    enableDeleteButton: boolean;
    removeForm: () => void;
}

const AdminInformationFormHeader: React.FC<AdminInformationFormHeaderProps> = ({ enableDeleteButton, removeForm }) => {
    return (
        <>
            <Row className="opux-spacing-top-margin" data-testid="AdminInformationFormHeader">
                <Col xs={11}>
                    <h2 data-testid="AdminInformationFormHeaderH2">{message('adminInformation')}</h2>
                </Col>

                {enableDeleteButton && (
                    <Col className="eservice-textalign-right" xs={1} data-testid="eservice-textalign-right">
                        <Button
                            icon={IconDelete}
                            iconLabel="Delete item"
                            minified
                            compact
                            onClick={removeForm}
                            data-testid="AdminInformationFormHeader"
                        />
                    </Col>
                )}
            </Row>
            <Row data-testid="AdminInformationTextRow">
                <Col data-testid="AdminInformationTextColumn">
                    <p data-testid="adminInformationInfoText">{message('adminInformationInfoText')}</p>
                </Col>
            </Row>
        </>
    );
};

export default AdminInformationFormHeader;
